const TOKEN_BLACKLIST_KEY = 'stocker_blacklisted_tokens';

const tokenBlacklistService = {
  // Get the local blacklist
  getLocalBlacklist: () => {
    try {
      const blacklist = localStorage.getItem(TOKEN_BLACKLIST_KEY);
      return blacklist ? JSON.parse(blacklist) : [];
    } catch (error) {
      console.warn('Error retrieving token blacklist:', error);
      return [];
    }
  },
    // Add a token to the local blacklist. Client-side only -- there is no
    // backend /blacklist-token route; real JWT invalidation happens server-side
    // via TokenBlacklistMiddleware, triggered automatically by POST /logout.
  addToBlacklist: (token, expiry) => {
    if (!token) return;

    try {
      const blacklist = tokenBlacklistService.getLocalBlacklist();
      const updatedBlacklist = [
        ...blacklist,
        { token, expiry, addedAt: Date.now() }
      ];
      localStorage.setItem(TOKEN_BLACKLIST_KEY, JSON.stringify(updatedBlacklist));
    } catch (error) {
      console.warn('Error blacklisting token:', error);
    }
  },

  // Check if a token is blacklisted
  isBlacklisted: (token) => {
    if (!token) return true;
    
    try {
      const blacklist = tokenBlacklistService.getLocalBlacklist();
      return blacklist.some(item => item.token === token);
    } catch (error) {
      console.warn('Error checking token blacklist:', error);
      return false;
    }
  },

  // Clean up expired blacklisted tokens
  cleanupBlacklist: () => {
    try {
      const blacklist = tokenBlacklistService.getLocalBlacklist();
      const now = Date.now();
      
      // Keep only non-expired tokens
      const updatedBlacklist = blacklist.filter(item => {
        const expiryTime = item.expiry * 1000; // Convert to milliseconds
        return expiryTime > now;
      });
      
      localStorage.setItem(TOKEN_BLACKLIST_KEY, JSON.stringify(updatedBlacklist));
    } catch (error) {
      console.warn('Error cleaning up token blacklist:', error);
    }
  }
};

export default tokenBlacklistService;